import { create } from "zustand";
import { PromptRequest, PromptTypeKey } from "../types/promptTypes";
import { BasicPayload, ErrorPayload } from "../types";
import pluto from "../plutoSdk";
import { initializePromptValues, isPromptValueValid } from "@plutoxyz/frame-js";
interface PromptStore {
  error?: ErrorPayload;
  prompts: PromptRequest[];
  metadata: BasicPayload;
  proxyUrl: string;
  setProxyUrl: (proxyUrl: string) => void;
  setError: (error: ErrorPayload) => void;
  setMetadata: (metadata: BasicPayload) => void;
  setPrompts: (prompts: PromptRequest[]) => void;
  promptValues: any[];
  setPromptValue: (index: number, value: any) => void;
  areValuesValid: boolean;
  validateValues: (prompts?: PromptRequest[]) => boolean;
}

export const usePromptStore = create<PromptStore>((set, get) => ({
  areValuesValid: false,
  proxyUrl: "",
  prompts: [],
  metadata: {
    title: "",
    description: "",
    icon: "",
    request_id: "",
  },
  error: undefined,
  setError: (error: ErrorPayload) => {
    set({ error });
    pluto.error(error);
  },
  setMetadata: (metadata: BasicPayload) => {
    set({ metadata });
  },
  setPrompts: (prompts: PromptRequest[]) => {
    const promptValues = initializePromptValues(prompts);

    set({
      prompts,
      promptValues,
    });

    // We do this after setting the prompts and promptValues
    // because we need the initial values
    set({ areValuesValid: get().validateValues() });
  },
  promptValues: [],
  setPromptValue: (index: number, value: any) => {
    set((state) => ({
      promptValues: [
        ...state.promptValues.slice(0, index),
        value,
        ...state.promptValues.slice(index + 1),
      ],
    }));

    // We do this after setting the prompts and promptValues
    // because we need the initial values
    set({ areValuesValid: get().validateValues() });
  },
  validateValues: () => {
    const promptValues = get().promptValues;
    return get().prompts.every((prompt, index) => {
      return isPromptValueValid(prompt, promptValues[index]);
    });
  },
  setProxyUrl: (proxyUrl: string) => {
    set({ proxyUrl });
  },
}));
